import { $, $$ } from '../utils/dom.js';
import { setupCustomCursor } from '../utils/custom-cursor.js';
import { Swiper } from '../vendor/vendor-globals.js';

export function initFeatureSlider() {
  const disposers = $$('[data-component="feature-slider"]').map((root) => setupFeatureSlider(root));

  return () => {
    disposers.forEach((dispose) => {
      dispose();
    });
  };
}

function setupFeatureSlider(root) {
  if (typeof Swiper !== 'function') {
    return () => { };
  }

  const viewport = $('.feature-slider__viewport', root);
  const currentEl = $('[data-feature-slider-current]', root);
  const totalEl = $('[data-feature-slider-total]', root);
  const prevBtn = $('[data-feature-slider-prev]', root);
  const nextBtn = $('[data-feature-slider-next]', root);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const slideCount = $$('.feature-slider__slide', viewport).length;
  const start = Number(root.getAttribute('data-feature-slider-start')) || 0;

  if (!viewport || slideCount < 2) {
    return () => { };
  }

  if (totalEl) {
    totalEl.textContent = pad(slideCount);
  }

  const updateCounter = (swiper) => {
    if (currentEl) {
      currentEl.textContent = pad(swiper.realIndex + 1);
    }
  };

  const syncAria = (swiper) => {
    swiper.slides.forEach((slide) => {
      slide.setAttribute('aria-hidden', slide.classList.contains('is-active') ? 'false' : 'true');
    });
  };

  const swiper = new Swiper(viewport, {
    wrapperClass: 'feature-slider__track',
    slideClass: 'feature-slider__slide',
    slideActiveClass: 'is-active',
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopedSlides: slideCount,
    loopAdditionalSlides: slideCount,
    spaceBetween: 24,
    initialSlide: start,
    speed: reduceMotion ? 0 : 1200,
    grabCursor: false,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      prevEl: prevBtn,
      nextEl: nextBtn,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 24,
      },
    },
    on: {
      init(swiperInstance) {
        updateCounter(swiperInstance);
        syncAria(swiperInstance);
      },
      slideChange(swiperInstance) {
        updateCounter(swiperInstance);
        syncAria(swiperInstance);
      },
    },
  });

  const disposeCursor = setupCustomCursor(root, '[data-feature-slider-cursor]');

  return () => {
    disposeCursor();
    swiper.destroy(true, true);
  };
}

function pad(value) {
  return String(value).padStart(2, '0');
}
